import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { ListGroup, Collapse } from "react-bootstrap";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
import { variables, colors, devices } from "./../../assets/styles/variables";
import { Link, navigate } from "gatsby";
import GlobalContext from "./../../context/GlobalContext";
import { Location } from '@reach/router';

const NestedMenuContainer = styled.div`
  a {
    color: ${colors.black} !important;
    font-weight: ${variables.mobileWeight} !important;
    transition: all 0.3s ease-out;
    &:hover,
    &:active {
      color: ${colors.red};
      text-decoration: none;
    }
  }

  .list-group {
    color: ${colors.black} !important;
    font-size: ${variables.mobileSize} !important;
    line-height: ${variables.mobileLine} !important;
    font-weight: ${variables.mobileWeight} !important;
    border-radius: 0px;
  }

  .list-group-item {
    span {
      color: ${colors.black} !important;
    }
    & + .collapse:not(.show) {
      .list-group-item {
        border: none !important;
        border-width: 0 !important;
      }
    }
    & + .collapse.show {
      .list-group-item {
        &:first-child {
          border-top: none !important;
        }
      }
    }
  }
  .collapse + .list-group-item {
    border-top-width: 0;
  }
  /* .list-group-flush:last-child .list-group-item:last-child {
    border-bottom-width: 1px;
  } */
`;

const defaultMenuItems:any = [
  { name: "home", label: "Home" },
  {
    name: "billing",
    label: "Billing",
    items: [
      { name: "statements", label: "Statements" },
      { name: "reports", label: "Reports" },
    ],
  },
  {
    name: "settings",
    label: "Settings",
    items: [
      { name: "profile", label: "Profile" },
      { name: "insurance", label: "Insurance" },
      {
        name: "notifications",
        label: "Notifications",
        items: [
          { name: "email", label: "Email" },
          {
            name: "desktop",
            label: "Desktop",
            items: [
              { name: "schedule", label: "Schedule" },
              { name: "frequency", label: "Frequency" },
            ],
          },
          { name: "sms", label: "SMS" },
        ],
      },
    ],
  },
];

const MenuItem = ({
  label,
  isExternal = false,
  name,
  items,
  depthStep = 20,
  depth = 0,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const [click, setClick] = useState(false);
  const hasSubItems = Array.isArray(items);

  const gContext:any = useContext(GlobalContext);

  useEffect(() => {
    if(click && name !== "#"){
      setClick(false);
      setOpen(false);
      navigate(name);
      if (gContext.visibleOffCanvas) {
        gContext.toggleOffCanvas();
      }
    }

  }, [open, click]);

  const hasLink = () => {    
    if(name !== "#"){
      gContext.toggleOffCanvas();
      navigate(name);
    } else {
      setOpen(!open);
    }
  };

  return (
    <>
      {hasSubItems ? (
        <ListGroup.Item
          {...rest}
          style={{ cursor: 'pointer'}}
          className={`d-flex align-items-center justify-content-between ${(name.includes('/') && (name !== ''))? 'active-mobile-menu-item' : ''}`}
        >
          <span onClick={() => hasLink()}>{label}</span>
          <span onClick={() => setOpen(!open)}>{open ? <FaAngleDown /> : <FaAngleRight />}</span>
        </ListGroup.Item>
      ) : (
        <ListGroup.Item
          {...rest}
          style={{cursor: 'pointer'}}
        >
          {isExternal ? (
            <a
              href={`${name}`}
              onClick={() => {
                if (gContext.visibleOffCanvas) {
                  gContext.toggleOffCanvas();
                }
              }}
            >
              {label}
            </a>
          ) : (
        <Location>
        {({ location }) => {
          return (
            <Link
              to={`/${name}`}
              className={(location.pathname.includes('/' + name) && (name !== '') || (location.pathname.includes('/cities') && name == 'areas')) ? 'active-mobile-menu-item' : ''}
              onClick={() => {
                if (gContext.visibleOffCanvas) {
                  gContext.toggleOffCanvas();
                }
              }}
            >
              {label}
            </Link>
          )
        }}
        </Location>
          )}
        </ListGroup.Item>
      )}

      {hasSubItems ? (
        <Collapse in={open}>
          <ListGroup>
            {items.map((subItem) => (
              <MenuItem
                key={subItem.name}
                depth={depth + 1}
                depthStep={depthStep}
                {...subItem}
              />
            ))}
          </ListGroup>
        </Collapse>
      ) : null}
    </>
  );
};

const NestedMenu = ({ menuItems = defaultMenuItems }) => {
  return (
    <NestedMenuContainer>
      <ListGroup variant="flush">
        {menuItems.map((menuItem, index) => (
          <MenuItem
            name={menuItem.name}
            key={`${menuItem.name}${index}`}
            depthStep={20}
            depth={0}
            {...menuItem}
          />
        ))}
      </ListGroup>
    </NestedMenuContainer>
  );
};

export default NestedMenu;
